/**
 * Merge /auth/me fields into the persisted session user (token + role UI permissions).
 * @param {object} meData - JSON body from GET /api/auth/me `data`
 */
export const mergeStoredUserFromMeData = (meData) => {
  if (!meData || typeof meData !== 'object') return;
  try {
    const raw = sessionStorage.getItem('user');
    if (!raw) return;
    const stored = JSON.parse(raw);
    if (!stored?.token) return;

    const next = {
      ...stored,
      id: meData._id || meData.id || stored.id,
      name: meData.name ?? stored.name,
      email: meData.email ?? stored.email,
      role: meData.role ?? stored.role,
      jobType:
        meData.jobType && typeof meData.jobType === 'object'
          ? meData.jobType.name ?? stored.jobType
          : meData.jobType ?? stored.jobType,
      jobTitle: meData.jobTitle ?? meData.job_title ?? stored.jobTitle,
      permissions: Array.isArray(meData.permissions) ? meData.permissions : stored.permissions,
      permissionOverrides:
        meData.permissionOverrides &&
        typeof meData.permissionOverrides === 'object' &&
        !Array.isArray(meData.permissionOverrides)
          ? meData.permissionOverrides
          : stored.permissionOverrides || {},
    };
    sessionStorage.setItem('user', JSON.stringify(next));
  } catch {
    // ignore corrupt storage
  }
};

